import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import QFS from "./pages/QFS";
import Web3 from "./pages/Web3";
import Plan401k from "./pages/Plan401k";
import TrumpGoldCard from "./pages/TrumpGoldCard";
import Medbed from "./pages/Medbed";
import CardApplication from "./pages/CardApplication";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qfs" element={<QFS />} />
          <Route path="/web3" element={<Web3 />} />
          <Route path="/401k" element={<Plan401k />} />
          <Route path="/trump-gold-card" element={<TrumpGoldCard />} />
          <Route path="/medbed" element={<Medbed />} />
          <Route path="/card-application" element={<CardApplication />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
